import {AppRegistry} from 'react-native';
import App from './src/App';
import {name as appName} from './app.json';
import './web.css';

Object.entriesTypeSafe = Object.entries;

AppRegistry.registerComponent(appName, () => App);
AppRegistry.runApplication(appName, {
  rootTag: document.getElementById('root'),
});
